<template>
  <div class="captcha">
    <vue-recaptcha ref="recaptcha" sitekey="6LdIceoUAAAAAFoVJbJNXrcPiF47eBQbc-h96O3F" @verify="verify" @expired="expired" />
    <span class="error">{{ error }}</span>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { VueRecaptcha } from "vue-recaptcha";
import { amplitudeTrack } from "@/utils/amplitude.ts";

defineOptions({
  name: "captcha",
});

defineProps({
  error: {
    type: [String, null],
    required: false,
    default: null,
  },
});

const emit = defineEmits(["onCaptchaVerify", "onCaptchaExpired"]);
const recaptcha = ref<VueRecaptcha | null>(null);

function reset() {
  recaptcha.value?.reset();
}

function verify(token: string) {
  emit("onCaptchaVerify", token);
}

function expired() {
  emit("onCaptchaExpired");
}

defineExpose({
  reset,
});

onMounted(() => {
  amplitudeTrack("Captcha show");
});
</script>

<style lang="scss">
@import "./index";
</style>
